import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { FormikTextField } from '../../../../components/form-components/common-components/text-field/FormikTextField';
import { AppointmentFormValues } from '../../../../models/appointment/AppointmentModel';
import { appointmentFieldIcons as AI } from './appointmentFieldIcons';
import styles from './NewAppointmentPopup.module.css';

const add30Minutes = (timeStr: string): string => {
  if (!timeStr || !/^\d{2}:\d{2}$/.test(timeStr)) return '';
  const [h, m] = timeStr.split(':').map(Number);
  let totalMinutes = h * 60 + m + 30;
  if (totalMinutes >= 24 * 60) totalMinutes = 24 * 60 - 1;
  const newH = Math.floor(totalMinutes / 60) % 24;
  const newM = totalMinutes % 60;
  return `${String(newH).padStart(2, '0')}:${String(newM).padStart(2, '0')}`;
};

const isTimeBeforeOrEqual = (a: string, b: string): boolean => {
  if (!a || !b) return false;
  const [ah, am] = a.split(':').map(Number);
  const [bh, bm] = b.split(':').map(Number);
  return ah < bh || (ah === bh && am <= bm);
};

export const AppointmentTimeFields = () => {
  const { values, setFieldValue } = useFormikContext<AppointmentFormValues>();

  useEffect(() => {
    if (values.appointmentStartTime) {
      const minEnd = add30Minutes(values.appointmentStartTime);
      const currentEnd = values.appointmentEndTime || '';
      if (!currentEnd || isTimeBeforeOrEqual(currentEnd, minEnd)) {
        setFieldValue('appointmentEndTime', minEnd);
      }
    }
  }, [values.appointmentStartTime, setFieldValue]);

  const minEndTime = values.appointmentStartTime ? add30Minutes(values.appointmentStartTime) : undefined;

  return (
    <>
      <div className={styles.inputContainer}>
        <FormikTextField
          name="appointmentStartTime"
          label="Randevu Başlangıç Saati"
          type="time"
          placeholder="Başlangıç saati"
          startIcon={AI.startTime}
          required
        />
      </div>
      <div className={styles.inputContainer}>
        <FormikTextField
          name="appointmentEndTime"
          label="Randevu Bitiş Saati"
          type="time"
          placeholder="Bitiş saati"
          startIcon={AI.endTime}
          required
          min={minEndTime}
        />
      </div>
    </>
  );
};
